import {PRESENTATIONS_LIST_PAGE_SIZE_DEFAULT_VALUES, SORT_DEFAULT} from '../../../constants';
import {UseListParamsReturn} from '../../../hooks/listParams';
import {useListSearchParams} from '../../../hooks/useListSearchParams';

export function usePresentationsListSearchParams(): UseListParamsReturn {
    return useListSearchParams(
        {size: PRESENTATIONS_LIST_PAGE_SIZE_DEFAULT_VALUES.initialPageSize, sortBy: SORT_DEFAULT},
        {sort: {allowedFields: ['name', 'lastModified']}, filterFields: {folder: {}}}
    );
}
